import request from '../../utils/request'

export default {
  getAll: data => request({
    url: '/api/services/app/question/GetAll',
    method: 'get',
    params: data
  }),
  get: data => request({
    url: '/api/services/app/question/Get',
    method: 'get',
    params: data
  }),
  getForEdit: data => request({
     url: '/api/services/app/question/GetForEdit',
     method: 'get',
     params: data
  }),
  create: data => request({
    url: '/api/services/app/question/Create',
    method: 'post',
    data: data
  }),
  update: data => request({
    url: '/api/services/app/question/Update',
    method: 'put',
    data: data
  }),
  delete: function(data) {
    return request({
      url: '/api/services/app/question/delete',
      method: 'delete',
      params: data
    })
  }
}
